import { useCallback, useSyncExternalStore } from 'react';

// Subscribe to a media query as state.
//
// useSyncExternalStore rather than useState in an effect: the effect version renders once with the
// wrong answer and then corrects itself, which on the register means the table mounts, measures and
// paints before being replaced by tiles. The store version reads the true value during the first
// render.
export default function useMediaQuery(query) {
  const subscribe = useCallback(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    // Server snapshot. Nothing renders this on a server today; false keeps the wide presentation as
    // the answer if anything ever does, because it is the one that degrades gracefully.
    () => false,
  );
}
